import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

const radiusSize = { small: '74%', medium: '84%', large: '104%' };

export default function TrainingStatusChart({
  scopedCount,
  statusCounts,
  totalCount,
}) {
  const [data, setData] = useState([]);

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const pieProps = {
    animationBegin: 150,
    animationDuration: 600,
    animationEasing: 'ease-in-out',
    data,
    dataKey: 'value',
    endAngle: -270,
    nameKey: 'name',
    startAngle: 90,
  };

  // using useEffect to force animation
  useEffect(() => {
    const chartData = [
      {
        className: 'tw-fill-grey-200',
        name: i18nTShared('noRequirements'),
        value: statusCounts.grey,
      },
      {
        className: 'tw-fill-green-400',
        name: i18nTShared('upToDate'),
        value: statusCounts.low,
      },
      {
        className: 'tw-fill-amber-300',
        name: i18nTShared('expiringSoon'),
        value: statusCounts.medium,
      },
      {
        className: 'tw-fill-red-500',
        name: i18nTShared('expiredMissing'),
        value: statusCounts.high,
      },
    ];

    setData(chartData);
  }, [statusCounts]);

  return (
    <div className='filter-container__chart'>
      <div className='filter-container__chart-block'>
        <Trans
          components={{
            h3: (
              /* eslint-disable-next-line jsx-a11y/heading-has-content */
              <h3 className='filter-container__info filter-container__info--black -tw-mt-1 tw-text-3xl tw-font-semibold tw-tracking-tighter' />
            ),
            p: (
              <p className='filter-container__sub-info filter-container__sub-info--black tw-max-w-[120px]' />
            ),
          }}
          i18nKey='personnel.countOfTotalCount'
          ns='common'
          values={{ count: scopedCount, totalCount }}
        />
      </div>
      <div className='filter-container__chart-container'>
        <ResponsiveContainer>
          <PieChart>
            <Pie
              dataKey='value'
              endAngle={-270}
              innerRadius={radiusSize.small}
              isAnimationActive={false}
              outerRadius={radiusSize.large}
              startAngle={90}
            >
              <Cell className='tw-fill-grey-100' strokeWidth={0} value={1} />
            </Pie>
            <Pie
              {...pieProps}
              innerRadius={radiusSize.small}
              isAnimationActive={true}
              outerRadius={radiusSize.large}
            >
              {data.map((entry, index) => (
                <Cell
                  className={entry.className}
                  key={`cell-${index}`}
                  strokeWidth={0}
                />
              ))}
            </Pie>
            <Pie
              dataKey='value'
              endAngle={-270}
              innerRadius={radiusSize.small}
              isAnimationActive={false}
              outerRadius={radiusSize.medium}
              startAngle={90}
            >
              <Cell
                className='tw-fill-grey-900 tw-opacity-5'
                strokeWidth={0}
                value={1}
              />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

TrainingStatusChart.propTypes = {
  scopedCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  statusCounts: PropTypes.object,
};

TrainingStatusChart.defaultProps = {
  statusCounts: {
    grey: 0,
    low: 0,
    medium: 0,
    high: 0,
  },
};
